const LAST_USED_CLINIC_KEY = 'synergrx.lastUsedClinicId';

export function getLastUsedClinic() {
    try {
        return window.localStorage.getItem(LAST_USED_CLINIC_KEY);
    } catch (e) {
        // ignore — storage disabled / privacy mode
        return null;
    }
}

export function setLastUsedClinic(clinicId) {
    // guard against '0'/undefined (logout / initial state) so we never persist a non-clinic
    if (clinicId && `${clinicId}` !== '0') {
        try {
            window.localStorage.setItem(LAST_USED_CLINIC_KEY, `${clinicId}`);
        } catch (e) {
            // ignore — quota / privacy mode
        }
    }
}
